import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7243ecd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fb-scanner" }
const _hoisted_2 = { class: "fb-scanner-crosshairs" }
const _hoisted_3 = { class: "fb-scanner-instuctions-container" }
const _hoisted_4 = { class: "fb-scanner-instruction title" }
const _hoisted_5 = {
  class: "fb-svg crosshairs",
  style: {"enable-background":"new 0 0 189 189"},
  version: "1.1",
  viewBox: "0 0 189 189",
  x: "0px",
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  y: "0px"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "fb-path crosshairs",
  d: "M145.5,175.5v-3h16c7.7,0,14-6.2,14-14c0,0,0,0,0,0l0-16h3v17c0,8.8-7.2,16-16,16L145.5,175.5z M26.5,175.5c-8.8,0-16-7.2-16-16l0-17h3v16c0,7.7,6.2,14,14,14c0,0,0,0,0,0l16,0v3H26.5z M175.5,40.5v-16c0-7.7-6.2-14-14-14 c0,0,0,0,0,0l-16,0v-3h17c8.8,0,16,7.2,16,16v17H175.5z M10.5,40.5l0-17c0-8.8,7.2-16,16-16h17v3h-16c-7.7,0-14,6.2-14,14 c0,0,0,0,0,0l0,16L10.5,40.5z"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "fb-scanner-button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgFlashlight = _resolveComponent("SvgFlashlight")!
  const _component_qrcode_stream = _resolveComponent("qrcode-stream")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_qrcode_stream, {
      paused: _ctx.paused,
      onDetect: _ctx.onDetect,
      onCameraOn: _ctx.onCameraOn,
      onError: _ctx.onError,
      torch: _ctx.flashlightActive
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.instructionText), 1)
          ]),
          (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.flashlightSupported)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "flashlight-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.flashlightActive = !_ctx.flashlightActive))
              }, [
                _createVNode(_component_SvgFlashlight, { color: _ctx.flashlightColor }, null, 8, ["color"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["paused", "onDetect", "onCameraOn", "onError", "torch"])
  ]))
}